// extracted by mini-css-extract-plugin
export var projectWrapper = "styles-module--projectWrapper--WltUQ";
export var centerContent = "styles-module--centerContent--jXo-0";
export var logo = "styles-module--logo--lGekS";
export var description = "styles-module--description--c8D2N";